import { ZonesFilter } from './../models/zona-filter';
import { Injectable } from '@angular/core';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';


const defaultSortParam = 'codi';
const defaultSortDirection = 'asc';

@Injectable()
export class ZonesFilterService extends CustomFilterService {

  public createFilterParams(filter: ZonesFilter, start: number, pageSize: number, sortField: string, sortDir: string) {
    return new HttpParams()
    .append('id', filter.id === null ? '' : filter.id.toString())
    .append('nomZona', filter.nomZona)
    .append('idMunicipi', filter.idMunicipi === null ? '' : filter.idMunicipi.toString())
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
